import Seo from './Seo'

/* Material */
import Container from '@mui/material/Container'
import Typo from '@mui/material/Typography'

import useStyles from './Brands.styles'

/* Types */
import { tBrands } from 'src/shared/frontendTypes/brand'
import type { BreadcrumbItem } from 'src/shared/frontendTypes/product'

/* Components */
import BrandsCarousel from './BrandsCarousel'
import BrandsList from './BrandsList'
import StaticBreadcrumbs from 'src/components/Breadcrumbs/StaticBreadcrumbs'

const breadcrumb: BreadcrumbItem[] = [
  { title: 'Marken' },
]

const Brands = (props:{brands:tBrands}) => {
  const { brands } = props
  const classes = useStyles()

  return <Container maxWidth='lg' className={classes.container}>

    <Seo brands={brands} />
    <StaticBreadcrumbs items={breadcrumb} />

    <Typo component='h1' variant='h4' color='inherit' gutterBottom>
      Marken von A bis Z
    </Typo>

    <Typo component='p' variant='body1' paragraph>
      Finden Sie Ihre Lieblingsmarke und entdecken Sie die Produkte im Sortiment.
    </Typo>

    <BrandsCarousel {...{brands}} />

    <hr />

    <BrandsList {...{brands}} />

  </Container>

}

export default Brands
